import { Badge } from '../common/Badge'

const styles = {
  New: 'bg-sky-100 text-sky-800 ring-1 ring-sky-200/60',
  Assigned: 'bg-violet-100 text-violet-800 ring-1 ring-violet-200/60',
  Contacted: 'bg-amber-100 text-amber-900 ring-1 ring-amber-200/60',
  'Follow-up': 'bg-orange-100 text-orange-900 ring-1 ring-orange-200/60',
  Qualified: 'bg-emerald-100 text-emerald-800 ring-1 ring-emerald-200/60',
  Converted: 'bg-green-100 text-green-800 ring-1 ring-green-200/60',
  Lost: 'bg-slate-200 text-slate-700 ring-1 ring-slate-300/60',
}

export function InquiryStatusBadge({ status }) {
  const c = styles[status] || 'bg-slate-100 text-slate-700 ring-1 ring-slate-200'
  return <Badge className={c}>{status}</Badge>
}
